import React from 'react';
import RemoveLineItemButton from 'Views/Components/_HumanWritten/LineItems/RemoveLineItemButton';
import If from 'Views/Components/If/If';
import { isNotNullOrUndefined, isNullOrUndefined, stringNotEmpty } from 'Util/TypeGuards';

export interface CartCalculationLineItemProps {
	lineItemDisplayName: string;
	lineItemDescription?: string;
	lineItemPrice: string;
	lineItemSubPrice?: string;
	className?: string;
	hasRemovalButton?: boolean;
	removalOnClick?: () => void;
	keyToUse?: string;
}

export function CartCalculationLineItem({
	lineItemDisplayName,
	lineItemDescription,
	lineItemPrice,
	lineItemSubPrice,
	className,
	hasRemovalButton = false,
	removalOnClick,
	keyToUse,
}: CartCalculationLineItemProps) {
	return (
		<div className={`cart-line-item__wrap ${className}`} key={`${keyToUse}-key`}>
			<div className="custom-underline">
				<div className="line-item-display-name__wrap">
					<p className="line-item-display-name">{lineItemDisplayName}</p>
					<p className="line-item-description">{lineItemDescription}</p>
				</div>
				<div className="line-item-price__wrap">
					<div className="line-item-price__removable-price">
						<If condition={hasRemovalButton && isNotNullOrUndefined(removalOnClick)}>
							{/* Shared with the anytime-ticket / parking review step. Keeps the
							    `clear-line-item__btn` class so this cart's own scoped rules still apply. */}
							<RemoveLineItemButton
								className="clear-line-item__btn"
								onClick={removalOnClick!}
								ariaLabel={`Remove ${lineItemDisplayName}`}
							/>
						</If>
						<If condition={!hasRemovalButton && isNullOrUndefined(removalOnClick)}>
							<div className="clear-line-item__btn">{'\u00A0'}</div>
						</If>
						<p className="line-item-price">{lineItemPrice}</p>
					</div>
					<p className="line-item-sub-price">{lineItemSubPrice}</p>
				</div>
			</div>
		</div>
	);
}
